export const headers = [
    { field: "id", headerName: "ID", width: 70, hidden: true },
    { field: "medida_descripcion", headerName: "Descripcion", width: 230 },
  ];
  